import React, {useState} from "react";
import usePartChip from "./usePartChip";


const PartChip = ({code, itemObject, codeKeyData}) => {
  const { partChipSelectHandler, switchData } = usePartChip(itemObject);

  const [hasError, setHasError] = useState(false);

  const renderImage = () => {
    if (!code) return null;

    if (hasError) {
      return (
        <div className="image-fallback font-sm">
          <div>No<br/>Image</div>
        </div>
      );
    }

    return (
      <img
        src={`${process.env.REACT_APP_image_path}/item/${itemObject.thumbnailImg}`}
        alt="Preview Thumbnail"
        onError={() => {
          setHasError(true);
        }}
      />
    );
  };


  return (
    <li className={`${(codeKeyData && switchData) && switchData.code === codeKeyData.CODE ? "active" : ""}`}>
      <div>
        <button type={"button"} onClick={() => partChipSelectHandler(code, itemObject, switchData)}>
          {/*<img src={process.env.REACT_APP_image_path+"/item/"+itemObject.thumbnailImg}/>*/}
          {renderImage()}
          <span>{itemObject.name || itemObject.nameEn}</span>
        </button>
      </div>
    </li>
  )
}

export default PartChip;
